import React, { FC } from "react";
import { Alert, Snackbar } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@store/store";
import { setMessage } from "@store/snackbarSlice";

const AUTO_HIDE_DURATION = 5000;

const MessageSnackbar: FC = () => {
  const message = useSelector((state: RootState) => state.snackbar.message);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(setMessage(null));
  };

  if (!message) {
    return null;
  }

  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      open={!!message}
      autoHideDuration={AUTO_HIDE_DURATION}
      onClose={handleClose}
    >
      <Alert variant="filled" severity={message.severity}>
        {message.content}
      </Alert>
    </Snackbar>
  );
};

export default MessageSnackbar;
